import { useState } from "react";

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [tip, setTip] = useState("");

  const handleSubscribe = () => {
    const value = email.trim();
    if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setTip("请输入正确的邮箱地址，便于接收更新提醒。");
      return;
    }
    setTip("订阅成功，新套图与视频上线时会第一时间提醒你。");
    setEmail("");
  };

  return (
    <section id="subscribe" className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="relative rounded-lg overflow-hidden bg-primary-500">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600/60 via-transparent to-accent-500/40" />
        <div className="relative z-10 px-5 md:px-12 py-10 md:py-14 flex flex-col lg:flex-row lg:items-center gap-8">
          <div className="lg:flex-1">
            <span className="inline-flex items-center gap-2 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25">
              <i className="ri-notification-3-line" />
              更新提醒 · 不错过任何上新
            </span>
            <h2 className="font-heading font-black text-background-50 text-2xl md:text-4xl leading-tight mt-5">
              订阅小蜜桃资源更新
            </h2>
            <p className="text-background-50/85 text-sm md:text-base mt-3 max-w-xl leading-relaxed">
              留下邮箱，在新增高清套图、视频资源与私拍福利专题上线时收到提醒。
              我们只推送与资源更新相关的信息，随时可以退订。
            </p>
          </div>

          <div className="lg:w-[420px] shrink-0">
            <div className="bg-background-50 rounded-lg p-4 md:p-5">
              <label className="block text-sm font-medium text-foreground-800 mb-2">
                接收提醒的邮箱
              </label>
              <div className="flex flex-col sm:flex-row gap-2.5">
                <div className="relative flex-1">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                    <i className="ri-mail-line text-sm" />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="w-full h-11 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleSubscribe}
                  className="inline-flex items-center justify-center gap-1.5 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
                >
                  <i className="ri-send-plane-line" />
                  立即订阅
                </button>
              </div>
              {tip && (
                <p className="text-xs text-foreground-600 mt-3 flex items-center gap-1.5">
                  <i className="ri-information-line text-primary-500" />
                  {tip}
                </p>
              )}
              <p className="text-[11px] text-foreground-400 mt-2">
                订阅为演示功能，不会真实发送邮件。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}